import ReactDOM from 'react-dom'

export type TReactRenderTarget = Element | DocumentFragment
export type TReactRenderNode = JSX.Element

export interface IReactRoot {
  render(reactNode: TReactRenderNode): void
  unmount(): void
}

export function createRoot(domNode: TReactRenderTarget, _options?: unknown): IReactRoot {
  return {
    render(reactNode: TReactRenderNode) {
      ReactDOM.render(reactNode, domNode)
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(domNode)
    }
  }
}
